import { jsx, useThemeUI } from '@theme-ui/core'
import { get } from '@theme-ui/css'
import { InterpolationWithTheme } from '@emotion/core'
import { forwardRefWithAs } from '@reach/utils'
import { SxStyleProp } from 'theme-ui'
import { SpaceProps, ColorProps } from 'styled-system'

export interface BaseProps extends SpaceProps, ColorProps {
  variant?: string
  sx?: SxStyleProp
  css?: InterpolationWithTheme<any>
}

export interface ElementProps extends BaseProps {
  __css?: SxStyleProp
  __themeKey?: string
}

const defaulStyles = {
  boxSizing: 'border-box',
  margin: 0,
  minWidth: 0,
}

export const Element = forwardRefWithAs<ElementProps, 'div'>(
  ({ sx, css, __css, __themeKey, variant, as, ...props }, ref) => {
    const { theme } = useThemeUI()
    const variantsCSS = getVariant({ theme, variant, __themeKey })
    const [styleProps, restProps] = getStyleProps(props)
    const elementStyles = theme
      ? theme.styles
        ? theme.styles.element
        : {}
      : {}
    const sxStyles = {
      ...defaulStyles,
      ...elementStyles,
      ...__css,
      ...variantsCSS,
      ...sx,
      ...styleProps,
    }

    return jsx(as || 'div', {
      sx: sxStyles,
      css: css,
      ref: ref,
      ...restProps,
    })
  }
)

const getVariant = ({ theme, variant, __themeKey = 'variants' }: any) =>
  get(theme, __themeKey + '.' + variant, get(theme, variant))

type Props = { [key: string]: any }

const getStyleProps = (props: Props) => {
  let sxStyleProps: Props = {}
  let restProps: Props = {}
  for (let key in props) {
    if (styleProps.includes(key)) {
      sxStyleProps[key] = props[key]
    } else {
      restProps[key] = props[key]
    }
  }
  return [sxStyleProps, restProps]
}

const styleProps = [
  'color',
  'bg',
  'margin',
  'm',
  'marginTop',
  'mt',
  'marginRight',
  'mr',
  'marginLeft',
  'ml',
  'marginBottom',
  'mb',
  'marginX',
  'mx',
  'marginY',
  'my',
  'padding',
  'p',
  'paddingTop',
  'pt',
  'paddingRight',
  'pr',
  'paddingBottom',
  'pb',
  'paddingLeft',
  'pl',
  'paddingX',
  'px',
  'paddingY',
  'py',
]
